<template>
  <v-row justify="center">

    <v-dialog
      v-model="show"
      max-width="600"
    >
      <v-card>

        <v-toolbar
          flat
          dark
          color="primary"
        >
          <v-toolbar-title>Übertragung zum Großhandel</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              @click="show = false"
              icon dark>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-title class="headline text-h2" style="word-break:normal;">

        </v-card-title>
        <v-card-text>
          <h3 v-if="totalAmount == 1">Es wird insgesamt {{ totalAmount }} Artikel übertragen.</h3>
          <h3 v-if="totalAmount > 1">Es werden insgesamt {{ totalAmount }} Artikel Positionen übertragen.</h3>
          Bitte achten Sie darauf, dass diese Anzahl auch in den Warenkorb des Großhandels übertragen wird.
          Nicht alle Artikel sind in den Großhandelsshops vernummert, weshalb manche Produkte nicht übertragen
          werden können. Falls nicht alle Artikel übertragen werden, kontaktieren Sie bitte Ihren Ansprechpartner
          beim entsprechenden Großhandel.

          <ul class="wgk-elbridge-list text-h4">
            <li v-for="(elbridgeItems, index) in products" :key="index">
              Art.-Nr. {{ elbridgeItems.number }} ({{ elbridgeItems.amount }} {{ elbridgeItems.vpeUnit }})
            </li>
          </ul>

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="secondary"
            text
            @click="show = false"
          >
            Schließen
          </v-btn>

          <form :action="elbridgeInterfaceURL" method="post" name="start" enctype="multipart/form-data" target="_blank">
            <input type="hidden" name="version" :value="elbridgeConfig.version">
            <input type="hidden" name="country" :value="elbridgeConfig.country">
            <input type="hidden" name="language" :value="elbridgeConfig.language">
            <input type="hidden" name="result" :value="JSON.stringify(elbridgeJSON)">
            <v-btn
              @click="trackElbridgePurchase"
              type="submit"
              depressed
              color="primary"
            >
              Übertragen
            </v-btn>
          </form>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import {dataLayer} from "../http-common";

export default {
  props: {
    value: Boolean,
    products: {
      type: Array,
      default: function () {
        return []
      }
    },
    elbridgeProducts: {
      type: Array,
      default: function () {
        return []
      }
    },
    elbridgeConfig: {
      type: Object,
      default: function () {
        return {}
      }
    },
  },
  methods: {
    trackElbridgePurchase() {
      dataLayer.push({
        'event': 'purchase',
        'ecommerce': {
          'currencyCode': 'EUR',
          'purchase': {
            'actionField': {
              'id': Date.now(),
              'affiliation': 'undefined',
              'revenue': 'undefined',
              'shipping': 'undefined',
              'tax':'undefined',
            },
            'products': this.elbridgeProducts
          }
        }
      });
    },
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    totalAmount: function () {
      return this.products.length
    },
    elbridgeInterfaceURL: function () {

      let hookURL = this.elbridgeConfig.interfaceUrl;

      if (this.$store.getters.elbridgeHookURL) {
        hookURL = this.$store.getters.elbridgeHookURL;
      }

      return hookURL;
    },
    elbridgeJSON: function() {

      let elbridgeItems = [];
      let elbridgeJson = {};

      for(let i in this.products) {

        let item = this.products[i];

        elbridgeItems.push({
          "SUPPLIER_ID_GLN": item.elbridgeInfo.SUPPLIER_ID_GLN,
          "ORDER_UNIT": item.elbridgeInfo.ORDER_UNIT,
          "MANUFACTURER_PID": item.elbridgeInfo.MANUFACTURER_PID,
          "MANUFACTURER_TYPE_DESCR": item.elbridgeInfo.MANUFACTURER_TYPE_DESCR,
          "DESCRIPTION_SHORT": item.elbridgeInfo.DESCRIPTION_SHORT,
          "QUANTITY": item.amount
        });
      }

      elbridgeJson.ITEM = elbridgeItems;
      elbridgeJson.CONFIGURATION_URL = this.elbridgeConfigurationUrl;

      return elbridgeJson;

    },
    elbridgeConfigurationUrl: function () {
      return window.location.origin + '/'+ this.$store.state.lang +'/wgk#' + this.$store.state.route.fullPath
    }
  }
}
</script>

<style lang="scss">

@import '../../src/sass/variables.scss';
@import '~vuetify/src/styles/settings/_variables';

.wgk-elbridge-list {
  list-style: none;
  padding-left: 0 !important;
  margin-left: 0 !important;
    li {
      margin: 5px 0;
    }
}

</style>
